import { GridReadyEvent, RowClassParams, RowNode } from 'ag-grid-community'
import { useCallback, useEffect, useRef } from 'react'
import { useWatch } from 'react-hook-form'

import { useGetByTenantRiskmanagementLatestHoldingstransferbalancesreconciliationQuery } from '@/api/rtk-api'
import { LoadingTable, Table } from '@/components/core-v2'
import { TENANT } from '@/const'

import { mapTableRowData, ReconciliationTableRowData } from '../reconciliation-utilities/map-data'
import classes from './reconciliation-table.module.scss'
import {
  COLUMN_DEFS,
  COLUMN_DEFS_FOR_LOADING,
  DEFAULT_COLUMN_OPTIONS
} from './reconciliation-table-columns'

export const ReconciliationTable = () => {
  const gridRef = useRef(null)
  const radio = useWatch({ name: 'assetRadioFilter' })
  const { data, isLoading } =
    useGetByTenantRiskmanagementLatestHoldingstransferbalancesreconciliationQuery({
      tenant: TENANT
    })

  const onGridReady = (event: GridReadyEvent) => {
    gridRef.current = event
  }

  useEffect(() => {
    gridRef.current?.api.onFilterChanged()
  }, [radio])

  const isExternalFilterPresent = useCallback(() => radio !== 'all', [radio])

  const doesExternalFilterPass = useCallback(
    (node: RowNode<ReconciliationTableRowData>) => {
      if (node.data) {
        switch (radio) {
          case 'break':
            return node.data.breaking
          case 'warning':
            return !node.data.breaking && node.data.warning
          default:
            return true
        }
      }
      return true
    },
    [radio]
  )

  if (isLoading)
    return (
      <LoadingTable
        agGridProps={{
          columnDefs: COLUMN_DEFS_FOR_LOADING,
          headerHeight: 60,
          rowHeight: 88
        }}
      />
    )

  return (
    <Table
      agGridProps={{
        rowClassRules: {
          [classes.break]: (params: RowClassParams<ReconciliationTableRowData>) =>
            params.data.breaking,
          [classes.warning]: (params: RowClassParams<ReconciliationTableRowData>) =>
            !params.data.breaking && params.data.warning
        },
        columnDefs: COLUMN_DEFS,
        defaultColDef: DEFAULT_COLUMN_OPTIONS,
        enableBrowserTooltips: true,
        headerHeight: 60,
        rowData: mapTableRowData(data?.entries),
        rowHeight: 88,
        isExternalFilterPresent,
        doesExternalFilterPass,
        onGridReady
      }}
      className={classes.root}
    />
  )
}
